export default __webpack_public_path__ + "static/media/lockedpage.f1685387.svg";